export default "__VITE_ASSET__d6mU2EbE__"